import {Component, Input} from '@angular/core';
import {Proposal} from '../../../model/proposal/proposal';

@Component({
    selector: 'app-insurance-contract-detail-partner-info',
    templateUrl: './insurance-contract-detail-partner-info.component.html',
    standalone: false
})
export class InsuranceContractDetailPartnerInfoComponent {

  @Input() proposal: Proposal;
}
